import * as React from "react";
import { Button, Form } from "antd";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";
import { PathDirectorySelect } from "Components/Form/PathDirectorySelect";

export interface MoveFilesFormProps extends WithTranslation, ModalComponentProps {
  files?: API_FileDataEntity[];
  defaultFolderId?: number; // preselected folderId
  onSubmitSuccess?: (folderId: number) => void;
  onMoveFile?: (files: Pick<API_FileDataEntity, "id" | "state">[], folderId: number) => Promise<void>;
  onLinkFile?: (files: Pick<API_FileDataEntity, "id" | "state" | "linkId">[], folderId: number) => Promise<void>;
  module?: API_MODULEDATA_MODULE | "LABELS_CALCULATOR";
  initialTreeData?: API_TreeElement;
  onCancel?: () => void; // if outside ModalConsumer
}

export const MoveFilesForm = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<MoveFilesFormProps, { loading: boolean }> {
      readonly state = { loading: false };
      handleFinish = async (values) => {
        const { t, hideModal, onMoveFile, onLinkFile, onCancel } = this.props;
        try {
          this.setState({ loading: true });
          if (onLinkFile) {
            await onLinkFile(this.props.files, values.folderId);
            onCancel ? onCancel() : hideModal();
            notificationSuccess(
              t("Success"),
              t(`${this.props.files.length > 1 ? "Links" : "Link"} successfully created`)
            );
          }
          if (onMoveFile) {
            await onMoveFile(this.props.files, values.folderId);
            onCancel ? onCancel() : hideModal();
            notificationSuccess(t("Success"), t("Files moved to selected folder."));
            if (typeof this.props.onSubmitSuccess === "function") {
              this.props.onSubmitSuccess(values.folderId);
            }
          }
        } catch (error) {
          throw error;
        } finally {
          this.setState({ loading: false });
        }
      };

      render() {
        const { loading } = this.state;
        const { t, defaultFolderId, module, initialTreeData } = this.props;
        return (
          <Form onFinish={this.handleFinish} initialValues={{ folderId: defaultFolderId?.toString() }}>
            <Form.Item
              name="folderId"
              label={t("Select destination path")}
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: t("This field is required") }]}
            >
              <PathDirectorySelect
                initialTreeData={initialTreeData}
                module={module}
                fileId={this.props.files?.length && this.props.files[0].id}
              />
            </Form.Item>
            <div className="text-right">
              <Button htmlType="submit" type="primary" loading={loading}>
                {t("Save")}
              </Button>
            </div>
          </Form>
        );
      }
    }
  )
);
